import useAct from '../useAct'
import CloseModal from './CloseModal.jsx'
import FlowStats from './FlowStats'
import BallotChart from './BallotChart'
import './PageContainer.scoped.scss'

function FlowHeader({ }) {
  const act = useAct()
  const { id, stats, status, slug, section, publicUrl } = useSel((s) => s.flow)
  const [showCloseModal, setShowCloseModal] = useState(false)
  const showPreviewIframe = !!slug

  const closeFlow = (redirectUrl) => {
    act.flow.close(id, redirectUrl)
    setShowCloseModal(false)
  }

  const reopenFlow = () => {
    act.flow.reopen(id)
  }

  return <div className='box gap' id='status'>
    <div className="poster-container" style={section === 'ballots' ? { width: '200px', background: 'white', padding: '24px' } : {}}>
      <div className="poster" style={section === 'ballots' ? { height: 'auto' } : {}}>
        {section === 'ballots' ? (
          <BallotChart stats={stats} />
        ) : showPreviewIframe ? (
          <iframe
            src={publicUrl}
            title="Embedded Page"
            className="iframe"
            loading="lazy"
          ></iframe>
        ) : (
          <SvgCircLoading />
        )}
      </div>
    </div>
    <div className='main'>
      <div className='header row'>
        <h1 className='no-margin-top'>{status === 'closed' ? 'Closed' : status ? 'Open' : ''}</h1>
        <div className='actions'>
          {status !== 'closed' &&
            <button className="button red primary" onClick={() => setShowCloseModal(true)}>
              Close
            </button>
          }
          {status === 'closed' &&
            <button className="button secondary" onClick={reopenFlow}>
              Re-open
            </button>
          }
          <CloseModal
            hide={() => setShowCloseModal(false)}
            onSubmit={closeFlow}
            open={showCloseModal}
          />
        </div>
      </div>
      <div className="flow-stats-wide">
        <FlowStats />
      </div>
    </div>
    <div className="flow-stats-narrow">
      <FlowStats />
    </div>
  </div>
}

export default FlowHeader
